




















import Vue from 'vue'
import { FileInfoDTO } from '@/Application/ReviewedDocumentation/FileInfoDTO'
import UploadReviewFile from '@/UI/UserProcedures/BidProcedures/Review/UploadReviewFile.vue'

export default Vue.extend({
  name: 'DocumentationTableRow',
  components: {
    UploadReviewFile
  },
  props: {
    fileItem: {
      type: FileInfoDTO,
      required: true
    },
    procedureId: {
      type: Number,
      required: true
    },
    batchId: {
      type: Number,
      required: true
    },
    madeiristaId: {
      type: Number,
      required: true
    }
  },
  computed: {
    statusClass (): string {
      if (this.fileItem.fileStatus === 'PRV') {
        return 'text-info'
      }
      if (this.fileItem.fileStatus === 'ERQ') {
        return 'text-danger'
      }
      return 'text-success'
    },
    icon (): string {
      if (this.fileItem.fileStatus === 'PRV') {
        return 'fa-info-circle'
      }
      if (this.fileItem.fileStatus === 'ERQ') {
        return 'fa-times-circle'
      }
      return 'fa-check-circle'
    }
  }
})
